import React from 'react';
import GdprConsentForm from 'MMT-UI/GdprConsentForm';

const GdprCookieConsentWrapper = () => <GdprConsentForm lob={'HOLIDAYS'} />;

export default GdprCookieConsentWrapper;
